import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const candidateService = {
  getAllCandidates: ({ page, ...params }: any) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllCandidates(),
      config: {
        params: {
          pageNumber: page || 1,
          ...params,
        },
      },
    });
  },

  getCandidate: (params: { candidateId: number }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getCandidate(),
      config: { params },
    });
  },

  downloadCandidateExcel: (params: any) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.downloadCandidateExcel(),
      config: { params },
    });
  },

  downloadAllCandidates: (data: {
    companyId: string; search: string; stores: any;
    userStatus: 'active' | 'inactive';
  }) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.downloadAllCandidates(),
      data: {
        companyId: data.companyId,
        name: data.search || '',
        userStatus: data.userStatus,
        stores: data.stores,
      },
    });
  },

  getFilteredCandidates: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.getFilteredCandidates(),
      data: {
        companyId: data.companyId,
        name: data.search || '',
        userStatus: data.userStatus,
        stores: data.stores,
      },
      config: { params: { pageNumber: data.page || 1 } },
    });
  },

  addNewCandidates: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.addNewCandidates(),
      data,
    });
  },

  editCandidate: (data: any) => {
    return axiosInstance.makePutRequest({
      url: apiUrls.editCandidate(),
      data,
    });
  },

  updateStatus: (data: { candidateMapId: number; isActive: number }) => {
    return axiosInstance.makePutRequest({
      url: apiUrls.updateStatus(),
      // data,
      config: { params: data },
    });
  },

  uploadCandidateExcel: ({ data, companyId }: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.uploadCandidateExcel(),
      config: { params: { companyId } },
      data,
    });
  },
};

export default candidateService;
